import { DataRow, isDataRow } from '@paragon/layout-models';

export function getFirstDataRowParent(row: DataRow<any>): DataRow<any> | null {
  if (!row.parent) {
    return null;
  }

  if (isDataRow(row.parent)) {
    return row.parent;
  }

  const dataRowParent = row.parent.parent;

  if (!dataRowParent) {
    return null;
  }

  if (!isDataRow(dataRowParent)) {
    throw new Error('Double nested containers are not supported.');
  }

  return dataRowParent;
}
